// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__MzQFX","slide":"Carousel_slide__9tP8M","active":"Carousel_active__qCnIl"};